import { FC } from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import Input from 'components/common/Input/Input';
import ELEMENT from 'common/element';

type FormValues = {
  disabledUntil: string;
};

type FormProps = {
  onClose: () => void;
  onSubmit: (disabledUntil: string | null) => void;
  filterName: string;
};

const initialValue: FormValues = {
  disabledUntil: '',
};

export const FilterDisableForm: FC<FormProps> = ({ onClose, onSubmit, filterName }: FormProps) => {
  const validationSchema = yup.object({
    disabledUntil: yup.number().min(0, 'Value must be 0 or greater.'),
  });

  /**
   * Add hours to the current time, then translate it into an ISO-8601 string.
   * Return null if hours isn't specified.
   */
  const calculateDisabledUntil = (hours: string | null): string | null => {
    if (hours) {
      // Converting to the ms
      const inputHours = parseInt(hours, 10) * 60 * 60 * 1000;
      const date = new Date(Date.now() + inputHours);
      return date.toISOString();
    }
    return null;
  };

  const handleSubmit = (values: FormValues): void => {
    const disabledUntil = calculateDisabledUntil(values.disabledUntil);
    onSubmit(disabledUntil);
    onClose();
  };

  return (
    <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={initialValue}>
      {({ handleChange, values, touched, errors, submitForm }): JSX.Element => (
        <>
          <div className="SectionHeader CostManagementTableForm__Title">Disable Filter</div>
          <p className="Filter FilterForm__Title">{filterName} Category</p>
          <Input
            name="disabledUntil"
            type="number"
            onChange={handleChange}
            value={values.disabledUntil}
            label="Hours to Disable"
            isInvalid={touched.disabledUntil && !!errors.disabledUntil}
            errorMessage={errors.disabledUntil}
            inputClassName="Filter FilterForm__Input"
            testId={ELEMENT.planPageDiscardFilterDisableFormUntilInput}
          />
          <p className="Filter FilterForm__SecondaryText">Leave empty to disable discard filter indefinitely.</p>
          <div className="Filter FilterForm__Buttons">
            <Button
              variant={ButtonVariant.PRIMARY}
              onClick={submitForm}
              testId={ELEMENT.planPageDiscardFilterDisableFormSaveButton}
            >
              Disable Filter
            </Button>
            <Button
              variant={ButtonVariant.SECONDARY}
              onClick={onClose}
              testId={ELEMENT.planPageDiscardFilterDisableFormCancelButton}
            >
              Cancel
            </Button>
          </div>
        </>
      )}
    </Formik>
  );
};
